import { INDEX_FALLBACK } from "@overmap-ai/common"
import type { IFuseOptions } from "fuse.js"

import type { FormSubmissionAndIdentifiers } from "../typings"

export const FORM_SUBMISSION_FUSE_OPTIONS: IFuseOptions<FormSubmissionAndIdentifiers> = {
	isCaseSensitive: false,
	threshold: 0.2,
	keys: [
		{
			name: "index",
			weight: 0.5,
			getFn: ({ formSubmission }) => formSubmission.index?.toString() ?? INDEX_FALLBACK,
		},
		{
			name: "identifiers",
			weight: 2,
			getFn: ({ identifierValues }) => identifierValues.map(({ value }) => value),
		},
	],
}
